<div class="assessment-container min-vh-100 bg-light" *ngIf="questions.length > 0">

  <!-- Header with Logo and Progress -->
  <div *ngIf="showSavedMessage"
    class="toast align-items-center text-bg-success border-0 position-fixed top-0 end-0 m-4  me-2 show shadow fade"
    role="alert">
    <div class="d-flex">
      <div class="toast-body fw-semibold">
        {{ message }}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" (click)="showSavedMessage = false"></button>
    </div>
  </div>

  <div class="container-fluid ">
    <div class="row justify-content-end">
      <div class="timer-badge col-auto px-4 py-2 mb-5 mt-2" style="font-weight: 500;">
        <span class="timer-label" >Time Remaining: </span>
        <span class="timer-clock"  [class.warning-time]="remainingTimeSeconds < 300">
          {{ formattedTime }}
        </span>
      </div>
      <div class="col-auto">
        <button (click)="exit()" class="btn btn-primary px-4 py-2 mb-5 mt-2"
          style="background-color: #0A1856; font-weight: 500;">
          Exit
        </button>
      </div>
    </div>


    <!-- Progress Header -->
    <div class="progress-header row align-items-center mb-3 mt-2">
      <div class="col-6">
        <h4 class="mb-0 fw-bold">Question {{ currentQuestionIndex + 1 }}:</h4>
      </div>
      <div class="col-6 text-end">
        <span class="badge bg-secondary fs-6">{{ currentQuestionIndex + 1 }} of {{ questions.length }}</span>
        <button (click)="exit()" class="exit-icon-btn" title="Exit assessment" aria-label="Exit assessment">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="progress " style="height: 8px;">
          <div class="progress-bar" role="progressbar"
            [style.width.%]="((currentQuestionIndex + 1) / questions.length) * 100"
            [attr.aria-valuenow]="currentQuestionIndex + 1" [attr.aria-valuemax]="questions.length">
          </div>
        </div>
      </div>
    </div>
  </div>



  <!-- Question Content -->
  <!-- <div class="container"> -->
  <div class="container mb-5">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10">
        <!-- <div class="question-card card shadow-sm border-0 mb-5"> -->
        <div class="card-body p-3">
          <!-- Question Text -->
          <h5 class="card-title text-dark mb-4 lh-base text-start">
            {{ questions[currentQuestionIndex].questionText }}
          </h5>

          <!-- Answer Options -->
          <div class="options-container">
            <div *ngFor="let option of questions[currentQuestionIndex].options; let j = index"
              class="form-check mb-3 p-3  option-item"
              [class.selected]="selectedAnswers[currentQuestionIndex] === option.questionOptionId">

              <input type="radio" class="form-check-input" name="question_{{currentQuestionIndex}}"
                id="option_{{currentQuestionIndex}}_{{j}}" [value]="option.questionOptionId"
                [(ngModel)]="selectedAnswers[currentQuestionIndex]" (change)="isSaved = false" />

              <label class="form-check-label w-100 cursor-pointer user-select-none"
                for="option_{{currentQuestionIndex}}_{{j}}">
                {{ option.optionText }}
              </label>
            </div>

            <!-- Clear Answer button -->
            <!--<button 
                  type="button" 
                  class="btn btn-outline-secondary btn-sm mt-2"
                  (click)="clearAnswer(currentQuestionIndex)">
                  Clear Answer
              </button>-->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Fixed Bottom Navigation -->
  <div class="fixed-bottom bg-white border-top py-3 shadow-sm">
    <div class="container">
      <div class=" navigation-buttons row justify-content-center gx-3">
        <!-- Previous Button -->
        <div class="col-12 col-md-3 mb-2 mb-md-0" *ngIf="currentQuestionIndex > 0; else spacer">
          <button (click)="previousQuestion()" class="btn btn-primary w-100 py-2">
            <i class="bi bi-chevron-left"></i>
            Previous
          </button>
        </div>

        <ng-template #spacer>
          <div class="col-12 col-md-3 mb-2 mb-md-0"></div>
        </ng-template>

        

        

        
        <div class="col-12 col-md-4 mb-2 mb-md-0 text-end">
          <button (click)="saveProgress()" class="save-icon-btn" title="Save Progress" aria-label="Save Progress">
          <i class="bi bi-save"></i>
        </button>
        </div>
        <div class="col-12 col-md-4" *ngIf="currentQuestionIndex === questions.length - 1">
          <button (click)="submitAnswers()" class="btn btn-success w-100 py-2"
            [disabled]="!selectedAnswers[currentQuestionIndex]">
            <i class="bi bi-check"></i>
            Submit Assessment
          </button>
        </div>

        <!-- Next/Submit Button -->
        <div class="col-12 col-md-3 mb-2 mb-md-0" *ngIf="currentQuestionIndex < questions.length - 1">
          <button (click)="nextQuestion()" class="btn btn-primary w-100 py-2"
            [disabled]="!selectedAnswers[currentQuestionIndex]">
            Next
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
        

      </div>
    </div>
  </div>

</div>

<!-- Loading State -->
<div *ngIf="questions.length === 0"
  class="loading-container min-vh-100 d-flex align-items-center justify-content-center">
  <div class="text-center">
    <ng-container *ngIf="!message; else noAssessment">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted">Loading questions...</p>
    </ng-container>

    <ng-template #noAssessment>
      <h5 class="text-muted">No assessment available for your account.</h5>
    </ng-template>
  </div>
</div>